// extracted by mini-css-extract-plugin
export default {"modal-overlay":"modal_modal-overlay__HXuNK","modal-content":"modal_modal-content__1Yxqm","modal-btn-close":"modal_modal-btn-close__QMKzZ"};